import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_lock",
  "use": "svg_lock-usage",
  "viewBox": "0 0 16 20",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 20\" id=\"svg_lock\"><path d=\"M6.75 13.124a1.25 1.25 0 1 1 2.5 0 1.233 1.233 0 0 1-.624 1.06v2.69h-1.25v-2.69a1.231 1.231 0 0 1-.626-1.06ZM15.5 8.75V20H.5V8.75H3V5a5 5 0 0 1 10 0v3.75h2.5Zm-11.25 0h7.5V5a3.75 3.75 0 1 0-7.5 0v3.75Zm10 1.25H1.75v8.75h12.5V10Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol